export const BG = {
  primary: "bg-[#0C1F3F]",
  primaryDark: "bg-[#071526]",
  light: "bg-[#F7F8FA]",
  lightMuted: "bg-[#F7F8FA]",
  surface: "bg-white",
  surfaceMuted: "bg-white/95",
  black: "bg-black",
  accent: "bg-[#FF6B35]",
};

export const BORDER = {
  primary: "border-[#0C1F3F]",
};

export const TEXT = {
  onPrimary: "text-white",
  primary: "text-[#0C1F3F]",
};
